import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

const getHeightBasedOnView = (
    quickOrder,
    modifySurgery,
    surgerySuccess,
    bannerMargin,
    transferSurgery
) => {
    const banner = bannerMargin ? bannerMargin : '0px';
    let height = `calc(100vh - 205px - ${banner})`;
    if (quickOrder) {
        height = `calc(100vh - 194px - ${banner})`;
    } else if (transferSurgery) {
        height = `calc(100vh - 200px - ${banner})`;
    } else if (modifySurgery) {
        height = `calc(100vh - 230px - ${banner})`;
    } else if (surgerySuccess) {
        height = `calc(100vh - 100px - ${banner})`;
    }

    return height;
};

export const UsageContainer = styled.div`
    background: #f5f5f5 0% 0% no-repeat padding-box;
    opacity: 1;
    width: 100%;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 1px;
    padding-right: 1px;
    padding-bottom: ${({ paddingBottom }) =>
        ENVIRONMENTVARIABLE
            ? `max(${
                  paddingBottom ? paddingBottom : '10vh'
              },calc(4*env(safe-area-inset-bottom)))`
            : paddingBottom
            ? paddingBottom
            : '10vh'};
    overflow-y: scroll;
    overflow-x: hidden;
    height: ${({ bannerMargin }) =>
        bannerMargin
            ? `calc(100vh - 205px - ${bannerMargin})`
            : 'calc(100vh - 205px)'};
    ${scrollBarStyle}

    //ipad Pro(10.5 inch) landscape
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        height: ${({ bannerMargin, showReportPayment }) =>
            bannerMargin
                ? `calc(100vh - 205px - ${bannerMargin})`
                : showReportPayment
                ? 'calc(100vh - 270px)'
                : 'calc(100vh - 205px)'};
        padding-bottom: 180px;
    }

    //ipad 9th gen landscape
    @media screen and (min-device-width: 1070px) and (max-device-width: 1100px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
        height: ${({ bannerMargin, showReportPayment }) =>
            bannerMargin
                ? `calc(100vh - 205px - ${bannerMargin})`
                : showReportPayment
                ? 'calc(100vh - 225px)'
                : 'calc(100vh - 205px)'};
        padding-bottom: ${({ showReportPayment }) => showReportPayment ? '180px' : null};
    }

    //ipad 9th gen landscape
    @media screen and (min-width: 1060px) and (max-width: 1110px) and (min-height: 670px) and (max-height: 820px) and (orientation: landscape) {
        height: ${({ bannerMargin, showReportPayment }) =>
            bannerMargin
                ? `calc(100vh - 205px - ${bannerMargin})`
                : showReportPayment
                ? 'calc(100vh - 225px)'
                : 'calc(100vh - 205px)'};
    }

    ${media.mediumDevice`
        height:${({ bannerMargin, showReportPayment }) =>
            bannerMargin
                ? `calc(100dvh - 255px - ${bannerMargin})`
                : showReportPayment
                ? 'calc(100dvh - 270px)'
                : 'calc(100dvh - 255px)'};
        padding-bottom: 180px;
    `}

    ${media.smalDevice`
        height:${({ bannerMargin }) =>
            bannerMargin
                ? `calc(100vh - 255px - ${bannerMargin})`
                : 'calc(100vh - 255px)'};
    `}

    ${media.mobileDevice`
        //Horizontal scroll remove
        width: 100%;
        //  curve issue
        border-top-left-radius: 25px;
        border-top-right-radius: 25px;
        padding-left:15px;
        padding-right:15px;
        padding-bottom: ${({ paddingBottom }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      paddingBottom ? paddingBottom : '10vh'
                  },calc(4*env(safe-area-inset-bottom)))`
                : paddingBottom
                ? paddingBottom
                : '10vh'};
        height:${({ usageOrderSubmission, bannerMargin }) =>
            usageOrderSubmission
                ? 'calc(100dvh - 100px)'
                : bannerMargin
                ? 'calc(100dvh - 180px)'
                : 'calc(100dvh - 169px)'};
        position:${(props) => (props.mbPosition ? props.mbPosition : 'fixed')};
        margin-top: 0px !important;
    `};
`;

export const MultiViewComponent = styled.div`
    flex: ${(props) => (props.flexRatio ? props.flexRatio : 0.5)};
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: none;
    align-items: ${(props) => (props.flexAlign ? props.flexAlign : 'center')};
    justify-content: ${(props) =>
        props.flexAlign ? props.flexAlign : 'space-between'};
    padding-bottom: ${(props) =>
        props.paddingBottom ? props.paddingBotttom : '31px'};
    ${media.smalDevice`
        flex: ${(props) => (props.flexRatio ? props.flexRatio : 1.0)};
    `}

    ${media.mobileDevice`
        flex-direction: ${(props) =>
            props.fDirection ? props.fDirection : 'column'};
        display: ${(props) => (props.displayType ? props.displayType : 'flex')};
        padding-top: ${(props) =>
            props.paddingTop ? props.paddingTop : '15px'};
        padding-bottom: ${(props) =>
            props.paddingBottom ? props.paddingBottom : '5px'};
        letter-spacing: 0px;
        align-items: flex-start;
    `}
`;

export const SurgeryContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    opacity: 1;
    overflow-y: ${(props) =>
        props.isScrollHide ||
        props.productSearch ||
        props.quickOrderHeight ||
        props.surgeryNotes
            ? 'none'
            : 'scroll'};

    /* overflow-x: hidden; */
    &::-webkit-scrollbar {
        display: ${(props) =>
            props.isScrollHide || props.isProductGuide || props.productSearch
                ? ''
                : props.theme.scrollOption.show};
        width: ${({ theme }) => theme.scrollOption.width};
    }
    &::-webkit-scrollbar-track {
        margin-top: 10px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }
    height: ${(props) =>
        getHeightBasedOnView(
            props.quickOrderHeight,
            props.isModifySurgery,
            props.surgerySuccess,
            props.bannerMargin,
            props.isTransferSurgery
        )};

    ${media.mediumDevice`
        height:${({ bannerMargin }) =>
            bannerMargin
                ? `calc(100vh -220px - ${bannerMargin})`
                : 'calc(100vh - 220px)'};
        &::-webkit-scrollbar {
            display: none;
        }
        
    `}
    ${media.mobileDevice`
        //Horizontal scroll remove
        overflow-x: hidden;
        width: 100%;
        //  curve issue
        border-top-left-radius: ${({ hideBorderRadius }) =>
            hideBorderRadius ? '0px' : '25px'};
        border-top-right-radius: ${({ hideBorderRadius }) =>
            hideBorderRadius ? '0px' : '25px'};
        flex-direction: column;
        padding: 0;
        height: ${({ mobileViewHeight }) => mobileViewHeight};
        //white line issue
        // padding-bottom:10vh;
        padding-bottom: ${({ paddingBottom }) =>
            ENVIRONMENTVARIABLE
                ? `max(${
                      paddingBottom ? paddingBottom : '10vh'
                  },calc(4*env(safe-area-inset-bottom)))`
                : paddingBottom
                ? paddingBottom
                : '10vh'};
        overflow-y: ${(props) =>
            props.quickOrderHeight || props.isProductGuide
                ? 'hidden'
                : 'scroll'};
    `};
`;

export const FindMaterialPopupContent = styled.div`
    width: 375px;
    height: 120px;
    ${media.mobileDevice`
        width: 310px;
        height: max-content;
    `};
    @media screen and (max-device-width: 375px) {
        width: auto;
    }
`;

export const FindMaterialPopupMessage = styled.div`
    height: 70px;
    font: 16px Avenir Next World;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    letter-spacing: -0.11px;
    opacity: 1;
    padding-top: 12px;
    ${media.mobileDevice`
        height: 120px;
        font: 15px Avenir Next World;
        font-family: 'AvenirNextWorld Regular';
    `};
`;

export const FindMaterialPopupButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    position: sticky;
    bottom: 0;
`;
